module.exports = __webpack_public_path__ + "e87423cfd6e834ae292c7c77910babaa.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-420.webp.png
// module id = 459
// module chunks = 0